<div class="vessel-list-item" data-cy="shipyard-folder-vessel-list-item" (click)="openVesselPage(vessel)">
    <div class="right-container">
        <mat-icon svgIcon="vessel" class="vessel-icon" data-cy="shipyard-folder-vessel-list-item-vessel-icon" />
        <div class="vessel-info-container">
            <div class="vessel-title" data-cy="shipyard-folder-vessel-list-item-vessel-number">
                {{ vessel.number }}
            </div>
            <div class="vessel-title" data-cy="shipyard-folder-vessel-list-item-vessel-name">
                {{ vessel.name }}
            </div>
            <div class="project-data">
                <div data-cy="shipyard-folder-vessel-list-item-no-of-ops">{{ vessel.numberOps }}{{ ' OPS' }}</div>
                <div class="separator"></div>
                <div data-cy="shipyard-folder-vessel-list-item-no-of-fcu">{{ vessel.numberFcu }}{{ ' FCU' }}</div>
                <div class="separator"></div>
                <div data-cy="shipyard-folder-vessel-list-item-no-of-mimics">
                    {{ getVesselMimics(vessel) }}{{ ' Mimics' }}
                </div>
            </div>
        </div>
    </div>
    <div class="left-container" data-cy="shipyard-folder-vessel-list-item-owner-section">
        <div *ngIf="vessel.ownerOid; else unassigned" class="owner-wrapper">
            <mat-icon
                [svgIcon]="getIcon(vessel)"
                class="vessel-icon"
                data-cy="shipyard-folder-vessel-list-item-status-icon"
                [ngClass]="{
                    pending: getIcon(vessel) === 'pending-approval',
                    approved: getIcon(vessel) === 'spaceship',
                }" />
            <div class="owner-text">
                <div data-cy="shipyard-folder-vessel-list-item-owner-label">
                    {{ 'shipyard.page.vessel.grid.owner.label' | translate }}
                </div>
                <div data-cy="shipyard-folder-vessel-list-item-owner-name">
                    {{ vessel.ownerName }}
                </div>
            </div>
        </div>
        <div *ngIf="vessel.ownerOid" class="picture-wrapper">
            <div *ngFor="let editor of vesselEditors">
                <img
                    src="{{ editor.image }}"
                    class="profile-picture-icon"
                    data-cy="shipyard-folder-vessel-list-item-owner-icon"
                    [matTooltip]="editor.name" />
            </div>
        </div>
    </div>
</div>

<ng-template #unassigned>
    {{ 'vessel.page.owner.unassigned' | translate }}
</ng-template>
